import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import Spinner from "app/popleads/components/ui-kit/Spinner";

/**
 * The app's loading indicator, and with 135 call sites the de-facto canonical one. It now
 * renders the kit's `Spinner`, so "the loader" has one implementation and takes its colour
 * from `ui-kit/colors.js` instead of inheriting whatever text colour surrounds it.
 *
 * Sized to what `react-bootstrap`'s Spinner rendered here before — a 32px box with a 4px
 * ring, measured, not guessed — so the screens keep their layout. What does change is the
 * colour. It used to inherit, which resolved to `#305073` — the body text colour, and not a
 * value the palette holds. It is now `primary[900]`, because this is the PopLeads-side
 * loader: 131 of its call sites are in the main app and none are in the extension, whose
 * brand is `l3rnTech`.
 *
 * The announcement moves from an `.sr-only` child to the kit Spinner's `aria-label`, which
 * is why the message is formatted here rather than rendered as a `<FormattedMessage>`.
 * `POPLEADS.LOADING` resolves in all six locale files, though every one of them currently
 * holds the same English string.
 *
 * @typedef {Object} LoadingSpinProps
 * @property {string} [classNames] - added to the wrapper, ahead of the layout classes
 */

/** @type {React.FC<LoadingSpinProps>} */
const LoadingSpin = ({ classNames }) => {
    const intl = useIntl();

    return (
        <div className={`${classNames ? classNames : ""}  centerEverything indicatorBox`}>
            <Spinner size={32} thickness={4} variant="primary" label={intl.formatMessage({ id: "POPLEADS.LOADING" })} />
        </div>
    );
};

LoadingSpin.propTypes = {
    classNames: PropTypes.string,
};

export default LoadingSpin;
